module.exports = __webpack_public_path__ + "media/images/home/down-arrow-6d8eb53b02cb2f62165bfdb97f57c050.png";